import ThankYouTemplate1 from "./ThankYouTemplate1";
import ThankYouTemplate2 from "./ThankYouTemplate2";
import ThankYouTemplate3 from "./ThankYouTemplate3";
import ThankYouTemplate4 from "./ThankYouTemplate4";
import ThankYouTemplate5 from "./ThankYouTemplate5";
import ThankYouTemplate6 from "./ThankYouTemplate6";
import ThankYouTemplate7 from "./ThankYouTemplate7";
import ThankYouTemplate8 from "./ThankYouTemplate8";
import ThankYouTemplate9 from "./ThankYouTemplate9";
import ThankYouTemplate10 from "./ThankYouTemplate10";
import ThankYouTemplate11 from "./ThankYouTemplate11";
import ThankYouTemplate12 from "./ThankYouTemplate12";
import ThankYouTemplate13 from "./ThankYouTemplate13";
import ThankYouTemplate14 from "./ThankYouTemplate14";
import ThankYouTemplate15 from "./ThankYouTemplate15";
import ThankYouTemplate16 from "./ThankYouTemplate16";
import ThankYouTemplate17 from "./ThankYouTemplate17";

// template_id (1-17) -> thank-you component, matching the sales/checkout family.
export const THANKYOU_TEMPLATES = {
  1: ThankYouTemplate1,
  2: ThankYouTemplate2,
  3: ThankYouTemplate3,
  4: ThankYouTemplate4,
  5: ThankYouTemplate5,
  6: ThankYouTemplate6,
  7: ThankYouTemplate7,
  8: ThankYouTemplate8,
  9: ThankYouTemplate9,
  10: ThankYouTemplate10,
  11: ThankYouTemplate11,
  12: ThankYouTemplate12,
  13: ThankYouTemplate13,
  14: ThankYouTemplate14,
  15: ThankYouTemplate15,
  16: ThankYouTemplate16,
  17: ThankYouTemplate17,
};

export function thankyouTemplateFor(id) {
  return THANKYOU_TEMPLATES[Number(id)] || THANKYOU_TEMPLATES[1];
}
